import React from 'react'

const Assets = () => {
  return (
    <div className=' mt-[10%] md:mt-[4%]'>Assets</div>
  )
}

export default Assets